import styles from "./style.module.css"

function Input({ required, customClass, ...props }) {
  return (
    <input
      {...props}
      className={styles[customClass]}
      required="required"
    />
  )
}
export default Input;